import { SideSheet } from 'components/Blocks';

import { useAppWrapper } from '../WrapperContext';
import { SideBarContent } from './SideContent';

import { cn } from 'styles';
import { LogoWithText } from 'components/Logos';

export function SideBar() {
  const { isSideBarOpen, showMobileSidebar, toggleSideBar } = useAppWrapper();

  if (showMobileSidebar) {
    return (
      <SideSheet
        className="border-l-0 bg-primary text-primary-foreground"
        isOpen={isSideBarOpen}
        close={toggleSideBar}
      >
        <LogoWithText />

        <SideBarContent />
      </SideSheet>
    );
  }

  return (
    <div
      className={cn(
        'relative w-16 flex-shrink-0 overflow-hidden bg-primary text-primary-foreground',
      )}
    >
      <SideBarContent />
    </div>
  );
}
